import { TimelinePosition } from "../../qualifiers/video/TimelinePosition.js";
/**
 * Create TimelinePosition from given ITimelinePositionModel
 * @param timelinePosition
 */

export function createTimelinePositionFromModel(timelinePosition) {
  var startOffset = timelinePosition.startOffset,
      endOffset = timelinePosition.endOffset,
      duration = timelinePosition.duration;
  var result = new TimelinePosition();

  if (startOffset) {
    result.startOffset(startOffset);
  }

  if (endOffset) {
    result.endOffset(endOffset);
  }

  if (duration) {
    result.duration(duration);
  }

  return result;
}